import { useState } from 'react';
import { NotebookPen } from 'lucide-react';
import type { Commerce } from './ShopCommerce';
import { shopWords } from './shopWords';
import { shopNames } from './shopNames';

// The cart's order note, drawn the same in the drawer and on the cart page: a quiet link opening a field
// whose words go with the order, open from the start once something is written.

// Draws Sleek's "Order note": a link that opens a field whose words go with the order.
export const OrderNote: React.FC<{ commerce: Commerce }> = ({ commerce }) => {
  const [open, setOpen] = useState(commerce.note !== '');
  return (
    <div className="xe-cart-order-note">
      <button type="button" aria-expanded={open} aria-controls="xe-cart-note-field" onClick={() => setOpen(!open)}><NotebookPen size={16} aria-hidden="true" />{shopWords(commerce.language).orderNote}</button>
      {open ? <textarea id="xe-cart-note-field" aria-label={shopWords(commerce.language).orderNote} placeholder={shopNames(commerce.language).noteHint} maxLength={500} rows={3} value={commerce.note} onChange={(event) => commerce.setNote(event.target.value)} /> : null}
    </div>
  );
};
